import { AxiosInstance } from "axios";
import { useAxios } from "../components/hooks/useAxios";
import { getBasicToken } from "../utils";
import {
  ForgotParam,
  ForgotPasswordControllerApiFp,
  ForgotUserIdParam,
  LoginControllerApiFp,
  RefreshControllerApiFp,
  RegistrationControllerApiFp,
  UpdatePasswordControllerApiFp,
} from "./generated/v1.0/open";
import {
  UpdateEmailAppControllerApiFp,
  UpdatePasswordAppControllerApiFp,
} from "./generated/v1.0/app";

// Login
export const loginRequest = async ({
  axios,
  tenantId,
  userId,
  password,
}: LoginRequestParams) => {
  const token = getBasicToken();
  return (
    await LoginControllerApiFp().loginUsingPOST(token, tenantId, {
      // new Configuration({
      //   basePath: "https://carina-api.arisaftech.com.bd",
      // })
      userId,
      password,
    })
  )(axios);
  // return res;
};

// Registration
export const getRegistrationDetailsRequest = async ({
  axios,
  tenantId,
  userId,
  password,
}: LoginRequestParams) => {
  const token = getBasicToken();
  return (
    await RegistrationControllerApiFp().detailUsingGET8(
      token,
      tenantId,
      password,
      userId,
    )
  )(axios);
};

export const submitRegistrationDetailsRequest = async ({
  axios,
  tenantId,
  userId,
  password,
  email,
}: EmailRegistrationParams) => {
  const token = getBasicToken();
  return (
    await RegistrationControllerApiFp().createUsingPOST6(token, tenantId, {
      userId,
      password,
      email,
    })
  )(axios);
};

export const submitEmailOtpRequest = async ({
  axios,
  tenantId,
  userId,
  password,
  email,
  otp,
}: EmailOtpParams) => {
  const token = getBasicToken();
  return (
    await RegistrationControllerApiFp().confirmUsingPOST(token, tenantId, {
      userId,
      password,
      email,
      otp,
    })
  )(axios);
};

export const changePassword = async ({
  axios,
  accessToken,
  oldPassword,
  newPassword,
}: PasswordChange) => {
  const token = getBasicToken();
  return (
    await UpdatePasswordAppControllerApiFp().changePasswordUsingPUT(
      accessToken,
      {
        oldPassword,
        newPassword,
      },
    )
  )(axios);
};

// Forgot password
export const forgotPasswordRequest = async ({
  axios,
  token,
  tenantId,
  param,
}: ForgotPasswordParams) => {
  return (await ForgotPasswordControllerApiFp().forgetPasswordUsingPOST(
    token,
    tenantId,
    param,
  ))(axios);
};

export const submitPasswordOtpRequest = async ({
  axios,
  tenantId,
  otp,
  userId,
}: PasswordOtpParams) => {
  const token = getBasicToken();
  return (await UpdatePasswordControllerApiFp().verifyOTPUsingGET(
    token,
    tenantId,
    otp,
    userId,
  ))(axios);
};

export const refreshAccessTokenRequest = async ({
  axios,
  refreshToken,
  tenantId,
}: OpenRequest & { refreshToken: string }) => {
  const token = getBasicToken();
  return (
    await RefreshControllerApiFp().refreshUsingPUT(
      token,
      tenantId,
      {
        refreshToken,
      },
    )
  )(axios);
};

// Change email
export const changeEmailRequest = async ({
  axios,
  accessToken,
  newEmail,
}: ProtectedRequest & { newEmail: string }) => {
  return (await UpdateEmailAppControllerApiFp().changeEmailRequestUsingPOST(
    accessToken,
    { newEmail, otp: 0 },
  ))(axios);
};

// Types
type LoginRequestParams = OpenRequest & {
  tenantId: string;
  userId: string;
  password: string;
};

type EmailRegistrationParams = LoginRequestParams & {
  email: string;
};

type EmailOtpParams = EmailRegistrationParams & {
  otp: number;
};

type ForgotPasswordParams = OpenRequest & {
  token: string;
  param: ForgotParam;
};

type PasswordOtpParams = OpenRequest & {
  userId: string;
  otp: number;
};

type PasswordChange = ProtectedRequest & {
  oldPassword: string;
  newPassword: string;
};
